import React, { useEffect, useRef, useState } from 'react'
import './view-rewards-modal.styles.scss'

import Modal from '@/components/modal/modal.component'
import { useSelector } from 'react-redux'
import { format, set } from 'date-fns'
import ImageContainer from '@/components/SHARED/image-container/image-container.component'
import HiddenText from '@/components/SHARED/hidden-text/hidden-text.component'
import { act } from 'react'
import { getGameActivityFromDb } from '@/utils/getDataFromDb'
import StackedCarouselContainer from '@/components/SHARED/stacked-carousel-container/stacked-carousel-container.component'

const ViewRewardsModal = ({
  playerData,
  isOpen,
  onClose,
  activity,
  modalHeadText
}) => {

  const screenSize = useSelector(state => state.contentData.screenSize);
  const [preview, setPreview] = useState(false);
  const [activityData, setActivityData] = useState(null);
  const [gifUrl, setGifUrl] = useState(null);
  const [gifs] = useState({
    'reward': '/images/icons/treasure2.gif',
    'achievement': '/images/icons/achievement2_gif.gif',
    'prizepack': '/images/icons/prizepack2_gif.gif'
  })
  const containerHeight = 300;
  const timeoutRef = useRef();
  const activityRef = useRef();

  useEffect(() => {

    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    }
  }, [])

  useEffect(() => {
    if (!isOpen || !playerData || !gifs || !activity) return;
    activityRef.current = { ...activity };
    setActivityData(activityRef.current);
    getActivityData();
    if (playerData.newStuff.find(n => n.id === activity.id) && activity.display !== 'momentum') {
      setPreview(true);
      // timeoutRef.current = setTimeout(() => {
      setGifUrl(gifs[activity.display]);
      // const el = document.getElementById('gif-container')
      // // if (el) {
      // console.log(el);
      //     el.src = gifs[activity.display];
      // }, 500);
      // }
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => {
        setGifUrl(null);
        // if (el) {
        const el = document.getElementById('gif-container')
        el.src = null;
        // } 
        setPreview(false);
      }, 3000);
    }
  }, [isOpen, playerData, gifs, activity])

  function getActivityData() {
    // console.log('getting activity data');
    getGameActivityFromDb({
      "gameId": playerData.gameId,
      "activityId": activity.id,
      "once": true,
      "callback": callback,
    })
    function callback(data) {
      activityRef.current = { ...Object.values(data)[0] };
      setActivityData(activityRef.current);
    }
  }

  return (
    <div className='view-rewards-modal'>
      <Modal
        show={isOpen}
        cancel={onClose}
        cls={
          screenSize === 'mobile'
            ? 'full'
            : screenSize === 'largeTablet'
              ? ''
              : 'narrow'
        }
        closeButton={true}
        text={
          activityData?.display === 'prizepack'
            ? 'New ' + activityData?.title + '!'
            : 'Your New Rewards!'
        } >
        {
          (preview)
            ?
            <div className='modal-children'>
              <ImageContainer
                id='gif-container'
                className='reward-gif'
                src={gifUrl}
              />
            </div>
            :
            (
              !preview &&
              activityData &&
              activityData.data &&
              activityData.display === 'prizepack'
            )
              ?
              <div className='slider-container'>
                <div className='slider'>
                  <StackedCarouselContainer
                    itemArr={
                      Object.values(activityData.data)
                        .map(a => {
                          return {
                            'cover': a.icon,
                            'title': a.title
                          }
                        })
                    }
                  />
                  {/* <StackedCarousel height={containerHeight}>
                            {
                                (
                                    activityData.data &&
                                    Object.values(activityData.data).length > 0
                                ) &&
                                Object.values(activityData.data).map((a, index) => (
                                    <div key={a.id + index} className='g-card'>
                                        <div className='slider-image-div'>
                                            <ImageContainer src={a.icon} className='slider-image' />
                                            {
                                                (a.quantity > 0) &&
                                                <div className='count-flag'>
                                                    x {a.quantity}
                                                </div>
                                            }
                                        </div>
                                        <div className='g-space-0-5'></div>
                                        <div className='center-col'>
                                            <p>Prize {index + 1}</p>
                                            <h3>{a.title.substring(a.title.indexOf(':') + 2, a.title.length +1)}</h3>
                                        </div>
                                    </div>
                                ))
                            }
                            </StackedCarousel> */}
                </div>
              </div>
              :
              (!preview && activityData)
                ?
                <div className='modal-children'>
                  <div className={`view-rewards-head g-list-item ${
                    activityData.display === 'momentum' &&
                    activityData.spec
                  }`}>
                    <div className={`view-rewards-title ${screenSize}`}>
                      <ImageContainer src={activityData.icon} alt='clickable treasure icon' className='view-rewards-big-icon' />
                      {
                        activityData.type !== 'secretCode' &&
                        <div className='activity-title'>{activityData.title}</div>
                      }
                    </div>
                    <div className='view-rewards-head-text'>

                      <div>
                        <span className='desc'>
                          {activityData.event}
                        </span>
                        <br />
                        {
                          (activityData.type === 'secretCode') &&
                          <HiddenText
                            text={activityData.title}
                            hidden={true} />
                        }

                        <div className='desc'>
                          {activityData.display === 'momentum' ? 'Received' : 'Earned'} {format(new Date(activityData.ts), 'Pp')}
                        </div>
                        {
                          (activityData.event === 'Secret Code Found') &&
                          <>
                            <b>{activityData.info}</b><br />
                          </>
                        }
                        {
                          (activityData.comments) &&
                          <>
                            <br />Evaluator comments:<br /><b>"{activityData.comments}"</b>
                          </>
                        }
                      </div>
                    </div>
                  </div>
                  {
                    (
                      (activityData &&
                      activityData.data &&
                      Object.values(activityData.data).length > 0) ||
                      activityData.type === 'momentum'
                    ) &&
                    <div className='earnings-box'>
                      <div className="g-space-1"></div>

                      <h2>{activityData.display === 'momentum' ? 'Results' : 'Rewards'}</h2>
                      <div className='earnings-list'>
                        {
                          activityData.spec === 'neutral'
                          ?
                          <div className='g-list-item earning-card neutral'>
                            This card was Neutral. No Changes!
                          </div>
                          :
                          Object.values(activityData.data).map((earning, index) => (
                            <div
                              key={index}
                              className={`g-list-item earning-card ${screenSize} ${
                                activityData.display === 'momentum' && 
                                activityData.spec
                              }`}>
                              <ImageContainer
                                src={earning.icon}
                                alt='reward icon'
                                className='earning-icon' />
                              <div className='earning-text'>
                                {
                                  (earning.title && earning.title.indexOf(':') > -1)
                                    ?
                                    <><b>{earning.title.split(': ')[1]}</b><br /><span>({earning.title.split(': ')[0]})</span></>
                                    :
                                    <b>{earning.title}</b>
                                }
                              </div>
                              {
                                (earning.quantity) &&
                                <div>x{earning.quantity}</div>
                              }
                            </div>
                          ))
                        }
                      </div>
                    </div>
                  }
                </div>
                : ''
        }
      </Modal>
    </div>
  )
}

export default ViewRewardsModal;